var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockUnlocked = function SvgLockUnlocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 1.28c-1.94 0-3.52 1.58-3.52 3.52v1.87A4.77 4.77 0 0 0 3.2 9.92c0 2.647 2.153 4.8 4.8 4.8 2.648 0 4.8-2.153 4.8-4.8 0-2.648-2.152-4.8-4.8-4.8a4.76 4.76 0 0 0-2.88.97V4.8A2.874 2.874 0 0 1 8 1.92c1.403 0 2.569.999 2.83 2.32a.32.32 0 0 0 .544.207.32.32 0 0 0 .076-.337A3.52 3.52 0 0 0 8 1.28m0 4.48a4.155 4.155 0 0 1 4.16 4.16A4.155 4.155 0 0 1 8 14.08a4.155 4.155 0 0 1-4.16-4.16A4.155 4.155 0 0 1 8 5.76m0 3.2a.958.958 0 0 0-.32 1.86v1.02h.64v-1.02A.958.958 0 0 0 8 8.96"
  })));
};
export default SvgLockUnlocked;